import React, {FC} from 'react';
import styled from 'styled-components';

import {StyledIndicatorContainerDiv} from './helpers';

/*
 * Props.
 */

interface IndicatorProps {}

/*
 * Style.
 */

const StyledIndicatorDiv = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(p) => p.theme.palette.blue.shade40};
`;

/*
 * Component.
 */

export const Indicator: FC<IndicatorProps> = () => (
  <StyledIndicatorContainerDiv>
    <StyledIndicatorDiv />
  </StyledIndicatorContainerDiv>
);
